<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入昵称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="短剧名称" prop="videoId">
                <!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id" allow-clear/>-->
                <a-tree-select v-model="queryParam.videoId" show-search style="width: 100%"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择短剧" allow-clear
                  tree-default-expand-all showSearch treeNodeFilterProp="title">
                  <a-tree-select-node :value="item.id" :key="item.id" :title="item.videoName"
                    v-for="(item, index) in listAll">
                  </a-tree-select-node>
                </a-tree-select>
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="剧集" prop="serialNumber">
                <a-input-number :min="1" v-model="queryParam.serialNumber" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="剧集id" prop="gatherId">-->
              <!--                  <a-input v-model="queryParam.gatherId" placeholder="请输入剧集id" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
              <!--              <a-col :md="8" :sm="24">-->
              <!--                <a-form-item label="花费金额" prop="price">-->
              <!--                  <a-input v-model="queryParam.price" placeholder="请输入花费金额" allow-clear/>-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons"
                :style="advanced && { float: 'right', overflow: 'hidden' } || {}">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
                <!--                  {{ advanced ? '收起' : '展开' }}-->
                <!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
                <!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!--        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:buy/video:add']">-->
        <!--          <a-icon type="plus" />新增-->
        <!--        </a-button>-->
        <!--        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:buy/video:edit']">-->
        <!--          <a-icon type="edit" />修改-->
        <!--        </a-button>-->
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['user:buy/video:remove']">
          <a-icon type="delete" />删除
        </a-button>

        <a-button type="primary" @click="toggleMode">
          {{ queryMode === 'episode' ? '查看整部剧购买' : '查看单集购买' }}
        </a-button>

        <!--        <a-button type="primary" @click="handleExport" v-hasPermi="['user:buy/video:export']">-->
        <!--          <a-icon type="download" />导出-->
        <!--        </a-button>-->
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" />
      <!-- 数据展示 -->
      <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
        :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['user:buy/video:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['user:buy/video:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['user:buy/video:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['user:buy/video:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
        :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange" @change="changeSize" :rowKey="(record, index) => index + 1" />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBuyVideo, listBuyVideo, delBuyVideo, pageByVideo } from '@/api/user/buyVideo'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import { listVideo } from '@/api/video/video'

export default {
  name: 'BuyVideo',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      queryMode: 'episode', // episode=单集, video=整部剧
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        videoId: null,
        gatherId: null,
        type: null,
        price: null,
        pageNum: 1,
        pageSize: 10
      },
      listAll: [],
    }
  },
  filters: {
  },
  created() {
    this.getList()
    this.getGather();

  },
  computed: {
    columns() {
      const base = [
        {
          title: '序号',
          customRender: (text, record, index) => index + 1,
          width: '10%',
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          width: '20%',
          align: 'center'
        },
        {
          title: '短剧名称',
          dataIndex: 'videoName',
          width: '20%',
          align: 'center'
        },
        {
          title: '花费金额',
          dataIndex: 'price',
          width: '10%',
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: '30%',
          align: 'center'
        }
      ]

      if (this.queryMode === 'episode') {
        base.splice(3, 0, {
          title: '剧集',
          dataIndex: 'serialNumber',
          width: '10%',
          align: 'center'
        })
        base.splice(4, 0, {
          title: '购买类型',
          dataIndex: 'type',
          width: '10%',
          align: 'center',
          customRender: (t) => {
            if (t == 0) return '免费'
            if (t == 1 || t == 2) return '金币'
            return ''
          }
        })
      }
      return base
    }
  },
  watch: {
  },
  methods: {
    getGather() {
      listVideo().then(res => {
        this.listAll = res.data;
      })
    },
    /** 查询用户购买剧集记录列表 */
    // getList() {
    //   this.loading = true
    //   const api = this.queryMode === 'episode' ? pageBuyVideo : pageByVideo
    //   api(this.queryParam).then(response => {
    //     this.list = response.data.records
    //     this.total = response.data.total
    //     this.loading = false
    //   })
    // },
    getList() {
      this.loading = true
      const api = this.queryMode === 'episode' ? pageBuyVideo : pageByVideo
      api(this.queryParam)
        .then(response => {
          let { records, total } = response.data

          // 如果是 video 模式，需要按 batchUnlockId 合并
          if (this.queryMode === 'video') {
            const map = new Map()
            const result = []

            records.forEach(item => {
              if (item.batchUnlockId) {
                if (map.has(item.batchUnlockId)) {
                  const exist = map.get(item.batchUnlockId)
                  exist.videoName = exist.videoName
                    ? exist.videoName + '&&' + item.videoName
                    : item.videoName
                  if (item.quantity) {
                    exist.quantity = (exist.quantity || 0) + item.quantity
                  }
                } else {
                  map.set(item.batchUnlockId, { ...item })
                  result.push(map.get(item.batchUnlockId))
                }
              } else {
                result.push(item)
              }
            })

            records = result
          }


          this.list = records
          this.total = total
          this.loading = false
        })
        .catch(() => {
          this.list = []
          this.total = 0
          this.loading = false
        })
    },


    toggleMode() {
      this.queryMode = this.queryMode === 'episode' ? 'video' : 'episode'
      this.queryParam.pageNum = 1
      this.getList()
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        userId: undefined,
        videoId: undefined,
        gatherId: undefined,
        type: undefined,
        price: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map(id => data.push({ "id": id }))
          return delBuyVideo(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download('user/user-buy-video/export', {
            ...that.queryParam
          }, `用户购买剧集记录_${new Date().getTime()}.xlsx`)
        },
        onCancel() { }
      })
    }
  }
}
</script>
